export function validDiceBid(
  quantity: number,
  face: number,
  minimum: { quantity: number; face: number },
  maxQuantity: number,
  allowedFaces: readonly number[],
): boolean {
  return (
    Number.isInteger(quantity) &&
    Number.isInteger(face) &&
    quantity >= 1 &&
    quantity <= maxQuantity &&
    allowedFaces.includes(face) &&
    (quantity > minimum.quantity ||
      (quantity === minimum.quantity && face >= minimum.face))
  );
}
